import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { EditEmployeeAPI, GetEmployeByEmail, GetEmployeeRole, GetEmployeeStatus } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash, FaStar } from "react-icons/fa";

function MyProfile() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const { employeeEmailId } = useParams();
  const [employeeData, setEmployeeData] = useState({});
  const [rolesData, setRolesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [fetchEmployeeData, setFetchEmplpoyeeData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    };
    const readableFormat = date.toLocaleString(undefined, options);
    return readableFormat.substring(0, readableFormat.length - 9);
  };

  useEffect(() => {
    (
      async () => {
        setLoading(true);
        try {
          const response = await GetEmployeByEmail(employeeEmailId, localStorage.getItem('accessToken'));
          const statusResponse = await GetEmployeeStatus(localStorage.getItem('accessToken'));
          const rolesResponse = await GetEmployeeRole(localStorage.getItem('accessToken'));
          setLoading(false);
          setStatusData(statusResponse.data.statuses);
          setRolesData(rolesResponse.data.roles);
          setEmployeeData(response.data[0]);
          setEditedEmployeeData(response.data[0]);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    )();
  }, [fetchEmployeeData]);

  const handleFirstNameChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.firstname = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleLastNameChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.lastname = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleEmployeeCodeChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.empcode = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handlePhoneNumberChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.employeephone = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleDesignationChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.designation = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleRoleChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.roleid = e.target.value;
    setEditedEmployeeData(temp);
  };

  // const getStatus = (statusid) => {
  //   return statusData.
  // };

  const handleStatusChange = (e) => {
    const temp = { ...editedEmployeeData };
    temp.statusid = e.target.value;
    setEditedEmployeeData(temp);
  };

  const handleDiscardClick = () => {
    const temp = { ...employeeData };
    setEditedEmployeeData(temp);
    toast.info("All unsaved changes have been discarded.");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    try {
      if (editedEmployeeData.firstname === "") {
        toast.error("First Name is required");
        return;
      }
      if (editedEmployeeData.lastname === "") {
        toast.error("Last Name is required");
        return;
      }
      if (editedEmployeeData.employeephone === "") {
        toast.error("Contact Number is required");
        return;
      }
      if (!editedEmployeeData.employeephone.match(/^\d{10}$/)) {
        toast.error("Invalid Contact Number.");
        return;
      }
      if (editedEmployeeData.designation === "") {
        toast.error("Designation is required");
        return;
      }
    } catch (error) {
       toast.error(error.message);
       window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      setEditLoading(true);
      const {
        firstname,
        lastname,
        empcode,
        employeephone,
        designation,
        emailid,
        statusid,
        roleid,
      } = editedEmployeeData;
      response = await EditEmployeeAPI(
        {
          firstname,
          lastname,
          empcode,
          employeephone,
          designation,
          emailid,
          statusid,
          roleid,
        },
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Profile Updated Successfully");
        setFetchEmplpoyeeData(!fetchEmployeeData);
        window.scrollTo(0, 0);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">My Profile</h1>
        </div>
        {
          loading ?
            <div className="d-flex align-items-center justify-content-center">
              <RiLoaderFill size={40} className="text-success spin-animation text-center" />
            </div>
            :
            <div role="tabpanel" className="personal-info tab-pane active" id="pi">
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleFirstNameChange} value={editedEmployeeData?.firstname} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName" className="d-flex align-items-center gap-1">
                      Firstname <FaStar size={7} className="text-danger" />
                    </label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleLastNameChange} value={editedEmployeeData?.lastname} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName" className="d-flex align-items-center gap-1">
                      Lastname <FaStar size={7} className="text-danger" /></label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-12 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handlePhoneNumberChange} value={editedEmployeeData?.employeephone} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName" className="d-flex align-items-center gap-1">
                      Phone Number <FaStar size={7} className="text-danger" />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input type="text" onChange={handleDesignationChange} value={editedEmployeeData?.designation} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName" className="d-flex align-items-center gap-1">
                      Designation <FaStar size={7} className="text-danger" />
                    </label>
                  </div>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input readOnly type="text" value={editedEmployeeData?.emailid} className="form-control" id="catName" placeholder="Product Main Category Name" />
                    <label htmlFor="catName" className="d-flex align-items-center gap-1">
                      Email ID <FaStar size={7} className="text-danger" />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-12 d-flex"
                  style={{ height: "40px", width: "120px" }}
                >
                  <button
                    type="submit"
                    disabled={editLoading}
                    onClick={handleDiscardClick}
                    style={{ height: "100%", width: "100%" }}
                    className="btn btn-danger save-btn text-uppercase"
                  >
                    Discard
                  </button>{" "}
                  &nbsp;
                  {editLoading ? (
                    <div
                      className="btn btn-primary loader-active save-btn"
                      style={{ height: "100%", width: "100%" }}
                    >
                      <RiLoaderFill
                        size={20}
                        className="spin-animation"
                        color="white"
                      />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      disabled={editLoading}
                      onClick={handleSubmitClick}
                      className="btn btn-primary save-btn text-uppercase"
                      style={{ height: "100%", width: "100%" }}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
         }
        <hr />
      </div >
    </div >
  );
}

export default MyProfile;